import React from "react";
import { Modal } from "@mui/material";
import "./DesignPendingModal.scss";

/**
 * DesignPendingModal
 *
 * Yeh modal tab show hota hai jab agency ne master design select nahi kiya hota.
 * Iske bina agent property post generate nahi kar sakta.
 *
 * @param {Object} props
 * @param {boolean} props.open - Modal open ya close state
 * @param {Function} props.onClose - Modal close karne ka handler
 */
const DesignPendingModal = ({ open, onClose }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      className="design-pending-modal"
      disableEscapeKeyDown
      aria-labelledby="design-pending-title"
    >
      <div className="design-pending-modal__card">
        <div className="design-pending-modal__icon-wrapper">
          <img
            src="/images/brand_verification_pending.svg"
            alt="Warning"
            className="design-pending-modal__icon"
          />
        </div>

        <h2 id="design-pending-title" className="design-pending-modal__title">
          Master Design Selection is Pending
        </h2>

        <p className="design-pending-modal__text">
          Your agency has not selected the master designs required to generate
          social media marketing content. You cannot generate property post
          content until a master design has been selected.
        </p>

        <p className="design-pending-modal__text">
          Please ask your agency to complete the master design selection to
          generate the marketing content.
        </p>

        <p className="design-pending-modal__text design-pending-modal__text--bold">
          If you are a Principal Agent or have access to the agency account,
          follow these steps to select designs
        </p>

        <ul className="design-pending-modal__list">
          <li>
            <span className="design-pending-modal__step-number">1.</span>
            <span className="design-pending-modal__step-text">
              Log in as Agency
            </span>
          </li>
          <li>
            <span className="design-pending-modal__step-number">2.</span>
            <span className="design-pending-modal__step-text">
              Navigate to Design Configuration from the left sidebar
            </span>
          </li>
          <li>
            <span className="design-pending-modal__step-number">3.</span>
            <span className="design-pending-modal__step-text">
              Select Image / Story Post Designs
            </span>
          </li>
          <li>
            <span className="design-pending-modal__step-number">4.</span>
            <span className="design-pending-modal__step-text">
              Browse the available designs and select a master design to start
              generating marketing content
            </span>
          </li>
        </ul>

        <button
          type="button"
          className="design-pending-modal__btn"
          onClick={onClose}
        >
          Done
        </button>
      </div>
    </Modal>
  );
};

export default DesignPendingModal;
